import { createSlice } from "@reduxjs/toolkit";
import { GET_BY_ID_USER_INTERPRETER_ACTION, GET_MILISTONE_USER_INTERPRETER_ACTION, GET_PLAN_USER_INTERPRETER_ACTION, GET_USERS_INTERPRETOR, USER_ACCOUNT_STATUS_ACTION, USER_INTERPRETER_LANGUAGE_COMMISION_ACTION, USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION, USER_INTERPRETO_ACCOUNT_ACTION, USER_INTERPRETO_ACCOUNT_APPROVE, USER_INTERPRETO_ACCOUNT_APPROVE_FIRST, USER_INTERPRETO_ACCOUNT_REJECT, USER_INTERPRETO_ACCOUNT_REJECT_FIRST, USER_RATE_AND_REVIEW_ACTION } from "./User.action";
const UsersSlice = createSlice({
    name: "users",
    initialState: {
        users: [],
        loading: false,
        error: null,
        users_interpreters_details: {},
        users_rate_and_review: [],
        users_milestone: {},
        user_Plan_details:{}
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_USERS_INTERPRETOR.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_USERS_INTERPRETOR.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload;
            })
            .addCase(GET_USERS_INTERPRETOR.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(GET_BY_ID_USER_INTERPRETER_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_BY_ID_USER_INTERPRETER_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.users_interpreters_details = action.payload;
            })
            .addCase(GET_BY_ID_USER_INTERPRETER_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(USER_ACCOUNT_STATUS_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_ACCOUNT_STATUS_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_ACCOUNT_STATUS_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            
            .addCase(USER_RATE_AND_REVIEW_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_RATE_AND_REVIEW_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.users_rate_and_review = action.payload;
            })
            .addCase(USER_RATE_AND_REVIEW_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(GET_MILISTONE_USER_INTERPRETER_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_MILISTONE_USER_INTERPRETER_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.users_milestone = action.payload;
            })
            .addCase(GET_MILISTONE_USER_INTERPRETER_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // =========== INTREPRETER_PROFILE_APPROVE =================
            .addCase(USER_INTERPRETER_LANGUAGE_COMMISION_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_INTERPRETER_LANGUAGE_COMMISION_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_INTERPRETER_LANGUAGE_COMMISION_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_APPROVE.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_APPROVE.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_APPROVE.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_REJECT.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_REJECT.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_REJECT.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            






            
            .addCase(USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(USER_INTERPRETO_ACCOUNT_APPROVE_FIRST.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_APPROVE_FIRST.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_APPROVE_FIRST.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            
            .addCase(USER_INTERPRETO_ACCOUNT_REJECT_FIRST.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_REJECT_FIRST.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(USER_INTERPRETO_ACCOUNT_REJECT_FIRST.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(GET_PLAN_USER_INTERPRETER_ACTION.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_PLAN_USER_INTERPRETER_ACTION.fulfilled, (state, action) => {
                state.loading = false;
                state.user_Plan_details = action.payload
            })
            .addCase(GET_PLAN_USER_INTERPRETER_ACTION.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            
            
    }
})
export default UsersSlice;